import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/PaymentDetail.css';
import { getPaymentDetail } from '../utils/api';

const PaymentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 결제 상세 정보 가져오기
  useEffect(() => {
    const fetchPaymentDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // API에서 결제 상세 정보 가져오기
        const response = await getPaymentDetail(id);
        console.log('결제 상세 응답:', response);
        
        if (response && response.status === 'success' && response.data) {
          // 결제 정보 포맷팅
          const data = response.data;
          
          // 날짜 포맷 변환
          const dateObj = new Date(data.date);
          const purchaseDate = `${dateObj.getFullYear()}년 ${dateObj.getMonth() + 1}월 ${dateObj.getDate()}일 ${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;
          
          // 금액 포맷팅
          const formattedAmount = `₩ ${data.amount.toLocaleString()}`;
          
          // 카드 정보 포맷팅
          let cardInfo = data.payment_method;
          if (data.detail && data.detail.card) {
            const cardCompany = data.detail.card.company || "";
            const cardNumber = data.detail.card.number || "";
            
            // 카드 회사명이 비어있으면 '카드'로 표시
            cardInfo = `${cardCompany ? cardCompany : '카드'} ${cardNumber}`;
          }
          
          setPaymentData({
            orderId: data.id || '',  // id 값을 거래 ID로 사용
            paymentMethod: cardInfo, // 카드 회사명 + 카드번호 + 카드타입
            purchaseDate: purchaseDate,
            plan: data.plan || 'TapGo Plus 플랜',
            period: data.period || `${data.start_date} ~ ${data.end_date}`,
            amount: formattedAmount,
            // 추가 필드가 있으면 여기에 추가
          });
        } else {
          setError('결제 정보를 불러올 수 없습니다.');
        }
        
        setLoading(false);
      } catch (err) {
        console.error('결제 상세 정보 로딩 오류:', err);
        setError('결제 정보를 불러오는 중 오류가 발생했습니다: ' + err.message);
        setLoading(false);
      }
    };
    
    if (id) {
      fetchPaymentDetail();
    } else {
      setError('유효한 결제 ID가 없습니다.');
      setLoading(false);
    }
  }, [id]);

  const handleRefundRequest = () => {
    console.log('환불 요청 페이지로 이동');
    navigate(`/dashboard/refund-request/${id}`);
  };

  const handleRefundPolicy = () => {
    console.log('환불 규정 확인');
    navigate(`/dashboard/refund-policy/${id}`);
  };

  // 로딩 중인 경우
  if (loading) {
    return (
      <div className="paymentDetailContainer">
        <h1 className="pageTitle">구매내역</h1>
        <div className="loadingMessage">정보를 불러오는 중...</div>
      </div>
    );
  }
  
  // 에러가 발생한 경우
  if (error) {
    return (
      <div className="paymentDetailContainer">
        <h1 className="pageTitle">구매내역</h1>
        <div className="errorMessage">{error}</div>
        <button 
          className="retryButton"
          onClick={() => window.location.reload()}
        >
          다시 시도
        </button>
      </div>
    );
  }
  
  // 데이터가 없는 경우
  if (!paymentData) {
    return (
      <div className="paymentDetailContainer">
        <h1 className="pageTitle">구매내역</h1>
        <div className="emptyMessage">결제 정보가 없습니다.</div>
      </div>
    );
  }

  return (
    <div className="paymentDetailContainer">
      <h1 className="pageTitle">구매내역</h1>
      
      <div className="paymentInfoBox">
        <p className="paymentInfoItem">거래 ID : {paymentData.orderId}</p>
        <p className="paymentInfoItem">결제방법 : {paymentData.paymentMethod}</p>
        <p className="paymentInfoItem">구매 일자 : {paymentData.purchaseDate}</p>
        <p className="paymentInfoItem">플랜 : {paymentData.plan}</p>
        <p className="paymentInfoItem">플랜 적용 기간 : {paymentData.period}</p>
        <p className="paymentInfoItem">금액 : {paymentData.amount}</p>
      </div>
      
      <div className="customerSupportSection">
        <h2 className="sectionTitle">고객지원</h2>
        
        <div className="supportButtons">
          <button className="supportButton" onClick={handleRefundRequest}>
            <span>환불 요청하기</span>
            <span className="arrowIcon">›</span>
          </button>
          
          <button className="supportButton" onClick={handleRefundPolicy}>
            <span>환불 규정 확인하기</span>
            <span className="arrowIcon">›</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetail; 